import { Injectable } from '@angular/core';
import { IS1SearchParams, S1HttpClientService } from '@app/s1';
import { map, Observable } from 'rxjs';
import { CheckType, IBaseOption } from '../models/models';

export interface ISearchCodiciModelloParams extends IS1SearchParams {
  codiceModello: string
}

export interface ISearchDescrizioneModelloParams extends IS1SearchParams {
  descrizioneModello: string
}

enum ModelloApi {
  codici = "/codici",
  descrizioni = "/descrizioni"
}

@Injectable({
  providedIn: 'root'
})
export class ModelloService {

  path = "/modello";

  constructor(private s1HttpClient: S1HttpClientService) { }

  getCodiciModello(parameters: ISearchCodiciModelloParams, type: CheckType, ui: boolean = false): Observable<IBaseOption[]> {
    return this.s1HttpClient.get(`/${type}${this.path}${ModelloApi.codici}`, parameters, ui).pipe(
      map(response => response.data.results)
    )
  }

  getDescrizioniModello(parameters: ISearchDescrizioneModelloParams, type: CheckType, ui: boolean = false): Observable<IBaseOption[]> {
    return this.s1HttpClient.get(`/${type}${this.path}${ModelloApi.descrizioni}`, parameters, ui).pipe(
      map(response => response.data.results)
    )
  }

}
